import { useEffect, useState } from 'react';
import { mobileAndTabletCheck } from "./checkMobileTablet";
var useIsMobileTablet = function useIsMobileTablet() {
  var _useState = useState(false),
    isMobileTablet = _useState[0],
    setIsMobileTablet = _useState[1];
  useEffect(function () {
    if (mobileAndTabletCheck()) {
      setIsMobileTablet(true);
    }
  }, []);
  return [isMobileTablet];
};
export { useIsMobileTablet };